import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateFullPage2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "none",
	viewBox: "0 0 1078 721",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 438.5,
			cy: 282.5,
			r: 184.5,
			fill: "#E9FFFE"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 686,
			cy: 227.5,
			fill: "#E9FFFE",
			rx: 200,
			ry: 200.5
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 825,
			cy: 413.5,
			fill: "#E9FFFE",
			rx: 253,
			ry: 253.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 207.5,
			cy: 383.5,
			r: 207.5,
			fill: "#E9FFFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#464A4A",
			d: "M196 86.404c13.794-1.259 25.778 1.554 33.102 14.362 1.831 3.199 3.221 1.229 4.927-.259 8.555-7.457 17.746-14.009 27.958-19.023 2.48-1.217 4.906-2.809 8.871-2.426-6.362 4.976-12.289 9.328-17.886 14.066-4.647 3.932-9.085 8.148-13.292 12.544-2.805 2.933-5.716 6.034-4.557 10.887.625 2.616-1.711 2.801-3.356 2.624-2.315-.251-.839-1.645-.575-2.772 1.238-5.256-2.46-8.135-5.832-10.755-7.386-5.742-15.266-10.792-23.372-15.477-2.04-1.18-3.993-2.509-5.988-3.772M277.339 152c5.643.321 8.299 2.665 10.697 5.532 4.351 5.203 7.588 11.117 11.088 16.875.839 1.382 1.492 4.413 4.141 2.64 6.416-4.289 14.538-3.524 21.094-7.654 5.449-3.434 11.223-.427 17.034 1.604-7.641 2.48-15.291 4.923-22.915 7.453-3.689 1.226-7.337 2.575-10.977 3.94-1.205.452-3.216.995-3.335 1.74-1.263 7.925-6.005 2.838-10.08 2.772 5.107-1.802 3.907-3.92 2.011-7.309-5.203-9.303-11.577-17.784-18.762-27.593z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#66C8CE",
			d: "M125.5 576.5C87.534 568.682 52.154 518.896 38 503h1010.1c14.38 0 9.99 14.854 5.99 22.281-10.66 24.756-31.97 82.478-31.97 115.313s-84.925 62.152-127.387 72.706c-66.441 16.515-352.884 1.564-443.603 0-90.719-1.563-114.73-49.122-115.397-72.706-26.476 9.903-90.119 23.767-132.881 0-53.452-29.708-29.894-54.322-77.352-64.094"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M409.65 570.502h-82.401a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h82.401a3.25 3.25 0 0 1 0 6.502M582.574 591.657H417.181a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h165.393a3.25 3.25 0 0 1 3.249 3.251 3.25 3.25 0 0 1-3.249 3.251M530.237 604.358H427.812a3.25 3.25 0 0 1 0-6.502h102.425a3.25 3.25 0 0 1 0 6.502"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M518.482 594.758c0-1.794 1.453-3.101 3.25-3.101h-18.606v6.205h18.606c-1.794 0-3.25-1.307-3.25-3.101z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M431.061 594.758c0 1.794-1.453 3.101-3.249 3.101h78.857v-6.205h-78.857c1.793 0 3.249 1.307 3.249 3.101zM794.65 621.502h-82.401a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h82.401a3.25 3.25 0 0 1 0 6.502M832.75 646.612h-82.401a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h82.401a3.25 3.25 0 0 1 3.249 3.251 3.25 3.25 0 0 1-3.249 3.251M870.48 634.202H722.879a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251H870.48a3.25 3.25 0 0 1 3.249 3.251 3.25 3.25 0 0 1-3.249 3.251M900.013 634.202h-12.257a3.25 3.25 0 0 1-3.249-3.251 3.25 3.25 0 0 1 3.249-3.251h12.257a3.25 3.25 0 0 1 0 6.502"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M786.084 624.603c0-1.794 1.453-3.101 3.249-3.101h-31.897v6.205h31.897c-1.793 0-3.249-1.307-3.249-3.101z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M726.129 624.603c0 1.794-1.453 3.101-3.249 3.101h42.528v-6.205H722.88c1.793 0 3.249 1.307 3.249 3.101zM829.5 637.009c0-1.794 1.453-3.101 3.249-3.101h-31.897v6.205h31.897c-1.793 0-3.249-1.307-3.249-3.101z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D4FDFB",
			d: "M769.545 637.009c0 1.794-1.453 3.101-3.249 3.101h42.528v-6.205h-42.528c1.793 0 3.249 1.307 3.249 3.101z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CED0E0",
			d: "M508.943 128.271h-50.158V361.32h50.158z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M538.413 128.271h-29.47V361.32h29.47z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M538.411 361.32h-29.468V128.271z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M470.28 137.379h-4.294v6.031h4.294zM480.734 137.379h-4.294v6.031h4.294zM491.188 137.379h-4.294v6.031h4.294zM501.639 137.379h-4.294v6.031h4.294zM470.28 154.825h-4.294v6.031h4.294zM480.734 154.825h-4.294v6.031h4.294zM491.188 154.825h-4.294v6.031h4.294zM501.639 154.825h-4.294v6.031h4.294zM470.28 172.275h-4.294v6.031h4.294zM480.734 172.275h-4.294v6.031h4.294zM491.188 172.275h-4.294v6.031h4.294zM501.639 172.275h-4.295v6.031h4.295zM470.28 189.723h-4.294v6.03h4.294zM480.734 189.723h-4.294v6.03h4.294zM491.188 189.723h-4.294v6.03h4.294zM501.639 189.723h-4.295v6.03h4.295zM470.28 207.173h-4.294v6.03h4.294zM480.734 207.173h-4.294v6.03h4.294zM491.188 207.173h-4.294v6.03h4.294zM501.639 207.173h-4.295v6.03h4.295zM470.28 224.622h-4.294v6.031h4.294zM480.734 224.622h-4.294v6.031h4.294zM491.188 224.622h-4.294v6.031h4.294zM501.639 224.622h-4.295v6.031h4.295zM470.28 242.07h-4.294v6.031h4.294zM480.734 242.07h-4.294v6.031h4.294zM491.188 242.07h-4.294v6.031h4.294zM501.639 242.07h-4.295v6.031h4.295zM470.28 259.519h-4.294v6.03h4.294zM480.734 259.519h-4.294v6.03h4.294zM491.188 259.519h-4.294v6.03h4.294zM501.638 259.519h-4.294v6.03h4.294zM470.28 276.968h-4.294v6.03h4.294zM480.734 276.968h-4.294v6.03h4.294zM491.188 276.968h-4.294v6.03h4.294zM501.638 276.968h-4.294v6.03h4.294zM470.28 294.416h-4.294v6.031h4.294zM480.734 294.416h-4.294v6.031h4.294zM491.188 294.416h-4.294v6.031h4.294zM501.638 294.416h-4.294v6.031h4.294zM470.28 311.865h-4.294v6.031h4.294zM480.734 311.865h-4.294v6.031h4.294zM491.188 311.865h-4.294v6.031h4.294zM501.639 311.865h-4.295v6.031h4.295zM470.28 329.315h-4.294v6.031h4.294zM480.734 329.315h-4.294v6.031h4.294zM491.188 329.315h-4.294v6.031h4.294zM501.639 329.315h-4.295v6.031h4.295zM470.28 346.764h-4.294v6.03h4.294zM480.734 346.764h-4.294v6.03h4.294zM491.188 346.764h-4.294v6.03h4.294zM501.639 346.764h-4.295v6.03h4.295z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B3B3B3",
			d: "M423.04 191.566h-59.942v172.082h59.942z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#757575",
			d: "M458.783 191.566h-35.745v172.082h35.745z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M414.517 196.798h-42.895v2.887h42.895zM414.517 205.152h-42.895v2.887h42.895zM414.517 213.507h-42.895v2.887h42.895zM414.517 221.86h-42.895v2.887h42.895zM414.517 230.214h-42.895v2.887h42.895zM414.517 238.571h-42.895v2.887h42.895zM414.517 246.925h-42.895v2.887h42.895zM414.517 255.279h-42.895v2.887h42.895zM414.517 263.634h-42.895v2.887h42.895zM414.517 271.988h-42.895v2.887h42.895zM414.517 280.342h-42.895v2.887h42.895zM414.517 288.695h-42.895v2.887h42.895zM414.517 297.05h-42.895v2.887h42.895zM414.517 305.404h-42.895v2.887h42.895zM414.517 313.759h-42.895v2.887h42.895zM414.517 322.113h-42.895V325h42.895zM414.517 330.467h-42.895v2.887h42.895zM414.517 338.823h-42.895v2.887h42.895zM414.517 347.178h-42.895v2.887h42.895zM414.517 355.531h-42.895v2.887h42.895z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CED0E0",
			d: "M449.709 196.798h-17.596v2.887h17.596zM449.71 205.152h-17.597v2.887h17.597zM449.71 213.507h-17.597v2.887h17.597zM449.71 221.86h-17.597v2.887h17.597zM449.71 230.214h-17.597v2.887h17.597zM449.71 238.571h-17.597v2.887h17.597zM449.71 246.925h-17.597v2.887h17.597zM449.71 255.279h-17.597v2.887h17.597zM449.71 263.634h-17.597v2.887h17.597zM449.71 271.988h-17.597v2.887h17.597zM449.71 280.342h-17.597v2.887h17.597zM449.71 288.695h-17.597v2.887h17.597zM449.71 297.05h-17.597v2.887h17.597zM449.71 305.404h-17.597v2.887h17.597zM449.71 313.759h-17.597v2.887h17.597zM449.71 322.113h-17.597V325h17.597zM449.71 330.467h-17.597v2.887h17.597zM449.71 338.823h-17.597v2.887h17.597zM449.71 347.178h-17.597v2.887h17.597zM449.71 355.531h-17.597v2.887h17.597z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M310.432 314.355s-5.004-24.812 19.063-28.414c14.477-2.168 10.218-11.765 23.559-17.03 11.002-4.341 19.319 3.117 27.649-.6 13.162-5.873 10.942-15.156 31.429-17.529 9.743-1.13 13.021-9.454 23.838-9.426 16.303.041 23.03 13.536 23.03 13.536v59.463H310.429z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5F89BA",
			d: "M690.006 503.42h-61.881V311.724l61.881-13.756z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#344B66",
			d: "M752.172 297.968H690.29V503.42h61.882z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "m538 456.355-115-6.605 6.248-135.395H538z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M468.072 345.031c0 11.936-12.543 21.614-12.543 21.614s-12.543-9.678-12.543-21.614c0-5.252 2.429-10.068 5.149-13.812 3.638-5.012 11.15-5.012 14.789 0 2.72 3.746 5.148 8.56 5.148 13.812"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M456.434 342.396h-1.808v53.49h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M499.47 345.031c0 11.936-12.543 21.614-12.543 21.614s-12.543-9.678-12.543-21.614c0-5.252 2.429-10.068 5.149-13.812 3.638-5.012 11.15-5.012 14.789 0 2.719 3.746 5.148 8.56 5.148 13.812"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M487.832 342.396h-1.808v36.285h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M530.868 345.031c0 11.936-12.543 21.614-12.543 21.614s-12.543-9.678-12.543-21.614c0-5.252 2.429-10.068 5.149-13.812 3.638-5.012 11.151-5.012 14.789 0 2.72 3.746 5.148 8.56 5.148 13.812"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M519.23 342.396h-1.808v36.285h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M563.994 393.659c0-5.924-15.148-10.725-33.836-10.725q-1.815 0-3.587.061c.107-.419.202-.84.202-1.267 0-8.364-21.398-15.146-47.791-15.146-6.823 0-13.301.46-19.171 1.277-1.394-5.517-15.934-9.859-33.698-9.859s-32.37 4.364-33.705 9.898a165 165 0 0 0-16.203-.784c-29.902 0-54.138 7.681-54.138 17.158 0 .307.095.606.143.911-4.618-.747-9.833-1.179-15.374-1.179-18.688 0-33.836 4.801-33.836 10.725s15.148 10.725 33.836 10.725c2.038 0 4.034-.058 5.971-.167 15.356 3.99 58.75 6.87 109.921 6.87 55.676 0 101.716 42.041 112.877 37.5C551.48 448.772 564 398.944 564 393.659z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "M583.267 90.526H538.41v223.838h44.857z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#565C80",
			d: "M628.125 314.364h-44.858V90.526l44.858 29.135z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M548.69 99.959h-3.839v210.016h3.839zM558.038 99.959h-3.839v210.016h3.839zM567.388 99.959h-3.839v210.016h3.839zM576.736 99.959h-3.839v210.016h3.839zM589.792 309.975h3.841v-207.57l-3.768-2.446h-.073zM602.981 309.975V108.477l-3.842-2.495v203.993zM612.329 309.975V114.547l-3.839-2.492v197.92zM621.677 309.975V120.619l-3.839-2.494v191.85z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5F89BA",
			d: "M690.006 314.363h-61.881V141.108l61.881-13.756z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#344B66",
			d: "M752.172 127.352H690.29v187.011h61.882z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M690.006 141.108h-61.881v2.375h61.881zM690.005 155.473h-61.881v2.374h61.881zM690.005 169.837h-61.881v2.374h61.881zM690.005 184.2h-61.881v2.375h61.881zM690.005 198.562h-61.881v2.375h61.881zM690.005 212.926h-61.881v2.374h61.881zM690.005 227.29h-61.881v2.374h61.881zM690.005 241.654h-61.881v2.375h61.881zM690.005 256.016h-61.881v2.374h61.881zM690.005 270.38h-61.881v2.374h61.881zM690.005 284.744h-61.881v2.375h61.881zM690.005 299.107h-61.881v2.375h61.881z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "M751.889 141.108h-61.881v2.375h61.881zM751.889 155.473h-61.881v2.374h61.881zM751.889 169.836h-61.881v2.374h61.881zM751.889 184.2h-61.881v2.375h61.881zM751.889 198.562h-61.881v2.374h61.881zM751.889 212.926h-61.881v2.374h61.881zM751.889 227.29h-61.881v2.374h61.881zM751.889 241.654h-61.881v2.375h61.881zM751.889 256.016h-61.881v2.374h61.881zM751.889 270.38h-61.881v2.374h61.881zM751.889 284.743h-61.881v2.375h61.881zM751.889 299.107h-61.881v2.375h61.881z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M737.563 326.803c-.778-1.011-.88-2.383-.344-3.543a13.85 13.85 0 0 0 1.272-5.811 13.83 13.83 0 0 0-4.837-10.521c-1.237-1.062-1.651-2.85-.859-4.275a9.3 9.3 0 0 0 1.164-4.404c.055-5.024-4.061-9.318-9.082-9.461-5.292-.15-9.627 4.095-9.627 9.354a9.3 9.3 0 0 0 1.165 4.516c.79 1.425.374 3.21-.861 4.273a13.84 13.84 0 0 0-4.836 10.52c0 2.077.457 4.047 1.272 5.816.54 1.171.411 2.55-.374 3.576a16.28 16.28 0 0 0-3.32 10.966c.512 8.209 7.3 14.888 15.512 15.279 9.387.445 17.137-7.036 17.137-16.325 0-3.747-1.261-7.2-3.38-9.955z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M665.574 332.629a10 10 0 0 0 .058-2.384c-.434-4.547-4.064-8.241-8.605-8.742a9.763 9.763 0 0 0-10.809 10.809c.402 3.553.012 7.179-1.431 10.45a12.1 12.1 0 0 0-1.002 5.702c.388 6.022 5.252 10.911 11.271 11.327 7.103.49 13.021-5.13 13.021-12.131 0-1.734-.363-3.381-1.019-4.873-1.399-3.19-1.987-6.712-1.484-10.158"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M656.196 334.311h-1.807v68.681h1.807z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M693.264 319.531c.147-1.012.177-2.063.076-3.139-.57-5.987-5.349-10.849-11.324-11.507-7.75-.857-14.312 5.19-14.312 12.77q0 .74.084 1.46c.528 4.675.013 9.449-1.884 13.754a16 16 0 0 0-1.319 7.507c.511 7.924 6.915 14.364 14.834 14.909 9.352.644 17.137-6.752 17.137-15.967 0-2.282-.478-4.453-1.339-6.417-1.84-4.199-2.618-8.834-1.953-13.37"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M680.589 321.658h-1.807v52.414h1.807zM724.858 319.851h-1.808v55.125h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "m356.916 314.364-22.978-22.025h72.368l22.978 22.025z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E6FDDE",
			d: "m334.088 292.317-22.971 22.026v62.137h45.943v-62.137z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M429.284 314.363h-72.368v62.113h72.368z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "m628.125 320.059-44.858-36.431v-41.151l44.858 36.428z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "m538.41 320.059 44.857-36.431v-41.151l-44.857 36.428z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m583.309 283.607-44.788 36.431v181.628h89.576V320.038z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CED0E0",
			d: "M555.977 343.094h-4.961v5.072h4.961zM555.977 358.312h-4.961v5.073h4.961zM555.977 373.533h-4.961v5.072h4.961zM570.864 327.875h-4.962v5.072h4.962zM570.864 343.094h-4.962v5.072h4.962zM570.864 358.312h-4.962v5.073h4.962zM570.864 373.533h-4.962v5.072h4.962zM585.75 312.656h-4.962v5.072h4.962zM585.75 327.875h-4.962v5.072h4.962zM585.75 343.094h-4.962v5.072h4.962zM585.75 358.312h-4.962v5.073h4.962zM585.75 373.533h-4.962v5.072h4.962zM600.636 327.875h-4.961v5.072h4.961zM600.636 343.094h-4.961v5.072h4.961zM600.636 358.312h-4.961v5.073h4.961zM600.636 373.533h-4.961v5.072h4.961zM615.522 343.094h-4.961v5.072h4.961zM615.522 358.312h-4.961v5.073h4.961zM615.522 373.533h-4.961v5.072h4.961zM555.977 388.752h-4.961v5.072h4.961zM570.864 388.752h-4.962v5.072h4.962zM585.75 388.752h-4.962v5.072h4.962zM600.636 388.752h-4.961v5.072h4.961zM615.522 388.752h-4.961v5.072h4.961z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#73DDDA",
			d: "M438.335 375.157c0 16.175-11.634 29.287-11.634 29.287s-11.633-13.112-11.633-29.287 11.633-29.287 11.633-29.287 11.634 13.112 11.634 29.287"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M427.606 370.002h-1.808v38.856h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "m426.704 382.818-4.936-5.047 1.29-1.263 3.646 3.725 3.643-3.725 1.292 1.263z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M401.881 376.195c0 14.288-10.276 25.868-10.276 25.868s-10.276-11.583-10.276-25.868c0-14.286 10.276-25.869 10.276-25.869s10.276 11.583 10.276 25.869"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M420.108 364.452c0 16.175-11.633 29.287-11.633 29.287s-11.634-13.112-11.634-29.287 11.634-29.287 11.634-29.287 11.633 13.112 11.633 29.287"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M409.38 360.883h-1.808v49.164h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M392.51 371.589h-1.808v37.666h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M447.447 423.913h-91.7v79.507h91.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C0C94D",
			d: "m355.747 423.913-26.238-28.8s30.038-12.23 46.907-.928c23.214 15.548 31.64 1.24 57.126 4.18 24.151 2.788 48.556 25.548 48.556 25.548H355.744z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M355.747 413.055c13.694-1.524 17.111 16.699 24.695 21.914 7.598 5.225 8.962-5.159 23.225-5.215 16.2-.062 12.566-6.61 21.33-10.904 8.364-4.1 18.961.474 22.447 5.063 11.278 14.837 49.454 52.07 49.454 52.07l-29.86-3.569-111.294-5.721v-53.638zM224.152 413.09c-13.695-1.524-17.112 16.699-24.696 21.915-7.598 5.224-8.962-5.16-23.225-5.216-16.2-.062-12.566-6.61-21.33-10.904-8.364-4.099-18.961.474-22.447 5.063C121.176 438.786 83 476.018 83 476.018l29.86-3.569 111.294-5.721V413.09z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "m372.883 411.718-10.606 37.004 30.017 12.056-11.843-49.053c-.975-4.037-6.585-4.044-7.571-.009z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M377.59 420.553h-1.807v28.91h1.807z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M375.782 442.043v-8.507l-4.008-6.333 1.526-.966 4.29 6.775v4.598l4.294-4.39 1.29 1.263z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "m391.094 410.055-11.155 55.594 30.566 3.324-11.843-58.909c-.974-4.037-6.584-4.044-7.57-.009z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M395.802 418.89h-1.808v41.558h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M393.994 440.378v-8.506l-4.008-6.331 1.526-.968 4.289 6.775v4.598l4.294-4.391 1.291 1.264z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C0C94D",
			d: "M355.747 445.224c9.502-2.485 20.935 4.472 26.362 10.433 5.43 5.962 8.921.331 15.706 2.65 8.939 3.053 15.154 13.019 25.626 11.363 10.47-1.656 17.809 3.211 17.809 3.211l6.197 30.539h-91.7zM164.7 445.224c-9.502-2.485-20.935 4.472-26.363 10.433-5.43 5.962-8.92.331-15.705 2.65-8.94 3.053-15.154 13.019-25.627 11.363-10.47-1.656-17.809 3.211-17.809 3.211L73 503.42h91.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M355.747 475.692c12.171-11.694 17.911 1.025 28.473-1.633 8.756-2.204 10.721-6.354 24.455-9.313 8.339-1.797 11.828.899 17.645-5.088 5.677-5.844 4.461-13.768 21.127-16.263 18.285-2.734 22.463 8.95 22.463 8.95l-4.799 14.101-13.178 36.974h-96.188v-27.726z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#08124A",
			d: "m482.776 423.913-17.663-18.059h55.634l17.663 18.059z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CED0E0",
			d: "m465.221 405.833-17.661 18.06v79.622h35.322v-79.622z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "M538.41 423.913h-55.634v79.507h55.634zM533.851 423.913l-17.665-18.059h-1.764l17.666 18.059z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "m526.394 423.913-17.666-18.059h-1.766l17.666 18.059zM518.935 423.913l-17.666-18.059h-1.764l17.666 18.059zM511.475 423.913l-17.663-18.059h-1.766l17.665 18.059zM504.019 423.913l-17.666-18.059h-1.764l17.666 18.059zM496.56 423.913l-17.664-18.059h-1.766l17.666 18.059zM489.102 423.913l-17.666-18.059h-1.763l17.665 18.059z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M190.067 343.941 145 389.897h120.611l45.068-45.956z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m310.771 343.923-45.134 45.954v113.637h90.268V389.877z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "m227.604 389.898-22.297-22.737h44.594z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E9EAF2",
			d: "m227.678 389.876-22.297-22.736-22.295 22.736h-37.961v113.637h120.512V389.876z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CED0E0",
			d: "M287.218 419.559h-4.428v5.143h4.428zM287.218 434.987h-4.428v5.144h4.428zM287.218 450.417h-4.428v5.144h4.428zM287.218 465.848h-4.428v5.143h4.428zM300.504 419.559h-4.428v5.143h4.428zM300.504 434.987h-4.428v5.144h4.428zM300.504 450.417h-4.428v5.144h4.428zM300.504 465.848h-4.428v5.143h4.428zM313.789 419.559h-4.428v5.143h4.428zM313.789 434.987h-4.428v5.144h4.428zM313.789 450.417h-4.428v5.144h4.428zM313.789 465.848h-4.428v5.143h4.428zM327.075 419.559h-4.428v5.143h4.428zM327.075 434.987h-4.428v5.144h4.428zM327.075 450.417h-4.428v5.144h4.428zM327.075 465.848h-4.428v5.143h4.428zM340.359 419.559h-4.428v5.143h4.428zM340.359 434.987h-4.428v5.144h4.428zM340.359 450.417h-4.428v5.144h4.428zM340.359 465.848h-4.428v5.143h4.428z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "M162.138 419.386h-5.666v18.713h5.666zM185.229 419.386h-5.665v18.713h5.665zM208.32 419.386h-5.665v18.713h5.665zM231.412 419.386h-5.666v18.713h5.666zM254.503 419.386h-5.666v18.713h5.666zM162.138 452.448h-5.666v18.713h5.666zM185.229 452.448h-5.665v18.713h5.665zM208.32 452.448h-5.665v18.713h5.665zM231.412 452.448h-5.666v18.713h5.666zM254.503 452.448h-5.666v18.713h5.666z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M733.48 372.95c-3.464 0-6.692.708-9.464 1.915-.72-6.995-8.695-12.51-18.448-12.51-7.816 0-14.488 3.544-17.207 8.552-3.274-2.137-7.583-3.449-12.318-3.449-9.582 0-17.463 5.319-18.421 12.138-3.097-1.7-6.932-2.72-11.102-2.72-10.228 0-18.52 6.06-18.52 13.534 0 .1.016.195.021.292-.007 0-.014-.005-.021-.007v112.66h124V386.482c0-7.476-8.292-13.534-18.52-13.534z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "m711.691 420.889-21.401-40.944h40.485l21.399 40.944z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M752.173 420.89h-40.482v82.53h40.482z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M690.431 379.924v123.589h21.24v-82.645z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "M736.452 436.904h-8.703v10.304h8.703zM736.452 460.5h-8.703v10.304h8.703z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M657.736 417.339c0 14.616-10.512 26.465-10.512 26.465s-10.511-11.849-10.511-26.465q.001-.61.023-1.21c.529-13.482 20.445-13.482 20.976 0q.025.604.024 1.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M648.129 424.91h-1.808v59.814h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M684.05 417.339c0 14.616-10.511 26.465-10.511 26.465s-10.512-11.849-10.512-26.465q.002-.61.023-1.21c.529-13.482 20.446-13.482 20.977 0q.023.604.023 1.21"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M674.444 424.91h-1.808v59.814h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#54A36A",
			d: "M689.626 489.703c0-8.723-6.888-20.681-15.386-20.681-4.526 0-8.581 2.017-11.397 5.212-.266-8.485-7.031-15.284-15.361-15.284-2.319 0-4.51.54-6.483 1.485.002-.113.016-.225.016-.341 0-8.724-6.887-15.797-15.385-15.797-3.466 0-6.652 1.191-9.224 3.176-.794-7.958-7.342-14.163-15.302-14.163-3.935 0-7.514 1.53-10.235 4.025-2.258-5.843-7.801-9.98-14.295-9.98-8.103 0-14.73 6.438-15.326 14.6a15 15 0 0 0-7.862-2.236c-8.498 0-15.386 7.073-15.386 15.797v47.839h152l-.377-13.649z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M579.175 455.036c-.778-1.012-.88-2.384-.344-3.543a13.85 13.85 0 0 0 1.272-5.811 13.83 13.83 0 0 0-4.837-10.521c-1.237-1.063-1.65-2.85-.859-4.275a9.3 9.3 0 0 0 1.164-4.405c.055-5.024-4.061-9.317-9.082-9.461-5.292-.15-9.627 4.096-9.627 9.355 0 1.64.425 3.178 1.166 4.515.789 1.425.373 3.211-.862 4.273a13.84 13.84 0 0 0-4.836 10.521c0 2.076.457 4.046 1.272 5.816.54 1.171.411 2.55-.374 3.575a16.28 16.28 0 0 0-3.32 10.966c.512 8.209 7.3 14.889 15.512 15.279 9.387.446 17.137-7.035 17.137-16.325 0-3.746-1.26-7.199-3.38-9.955z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#73DDDA",
			d: "M609.965 459.937c.118-.806.141-1.642.06-2.497-.455-4.762-4.257-8.631-9.011-9.158a10.227 10.227 0 0 0-11.322 11.322c.421 3.721.012 7.521-1.5 10.946a12.7 12.7 0 0 0-1.051 5.973c.407 6.305 5.502 11.428 11.805 11.865 7.44.513 13.637-5.373 13.637-12.706 0-1.815-.381-3.543-1.064-5.107-1.464-3.339-2.083-7.03-1.554-10.638"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M599.278 461.729h-1.807v41.569h1.807zM565.849 448.174h-1.808v55.125h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M790.008 67h-37.834v353.889h37.834z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M790.006 89.305h-37.671v6.557h37.671zM790.006 111.609h-37.671v6.558h37.671zM790.006 133.914h-37.671v6.557h37.671zM790.006 156.219h-37.671v6.557h37.671zM790.006 178.523h-37.671v6.558h37.671zM790.006 200.828h-37.671v6.557h37.671zM790.006 223.133h-37.671v6.557h37.671zM790.006 245.436h-37.671v6.557h37.671zM790.006 267.74h-37.671v6.557h37.671zM790.006 290.045h-37.671v6.557h37.671zM790.006 312.35h-37.671v6.557h37.671zM790.006 334.654h-37.671v6.558h37.671z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E9EAF2",
			d: "M850.938 67h-60.932v353.889h60.932z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#848BB2",
			d: "M825.255 89.305h-11.638v6.557h11.638zM808.771 89.305h-11.638v6.557h11.638zM841.738 89.305H830.1v6.557h11.638zM808.771 111.609h-11.638v6.558h11.638zM841.738 111.609H830.1v6.558h11.638zM825.255 111.609h-11.638v6.558h11.638zM808.771 133.914h-11.638v6.557h11.638zM841.738 133.914H830.1v6.557h11.638zM825.255 133.914h-11.638v6.557h11.638zM841.738 156.219H830.1v6.557h11.638zM808.771 156.219h-11.638v6.557h11.638zM825.255 156.219h-11.638v6.557h11.638zM825.255 178.523h-11.638v6.558h11.638zM808.771 178.523h-11.638v6.558h11.638zM841.738 178.523H830.1v6.558h11.638zM841.738 200.828H830.1v6.557h11.638zM808.771 200.828h-11.638v6.557h11.638zM825.255 200.828h-11.638v6.557h11.638zM841.738 223.133H830.1v6.557h11.638zM825.255 223.133h-11.638v6.557h11.638zM808.771 223.133h-11.638v6.557h11.638zM841.738 245.436H830.1v6.557h11.638zM808.771 245.436h-11.638v6.557h11.638zM825.255 245.436h-11.638v6.557h11.638zM808.771 267.74h-11.638v6.557h11.638zM825.255 267.74h-11.638v6.557h11.638zM841.738 267.74H830.1v6.557h11.638zM825.255 290.045h-11.638v6.557h11.638zM841.738 290.045H830.1v6.557h11.638zM808.771 290.045h-11.638v6.557h11.638zM808.771 312.35h-11.638v6.557h11.638zM825.255 312.35h-11.638v6.557h11.638zM841.738 312.35H830.1v6.557h11.638zM841.738 334.654H830.1v6.558h11.638zM808.771 334.654h-11.638v6.558h11.638zM825.255 334.654h-11.638v6.558h11.638z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M980.706 146.841v-16.043h-80.254v16.043h-4.959v356.67h84.968v-356.67z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M975.504 146.841h-80.011v356.67h84.968v-356.67z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#17AD86",
			d: "M947.018 130.798h-96.08v372.713h96.08z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M947.018 130.798h-96.08v16.043h96.08z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M877.778 169.388h-8.833v16.567h8.833zM894.857 169.388h-8.833v16.567h8.833zM911.935 169.388h-8.833v16.567h8.833zM929.012 169.388h-8.833v16.567h8.833zM877.778 197.998h-8.833v16.567h8.833zM894.857 197.998h-8.833v16.567h8.833zM911.935 197.998h-8.833v16.567h8.833zM929.012 197.998h-8.833v16.567h8.833zM877.778 226.605h-8.833v16.568h8.833zM894.857 226.605h-8.833v16.568h8.833zM911.935 226.605h-8.833v16.568h8.833zM929.012 226.605h-8.833v16.568h8.833zM877.778 255.217h-8.833v16.567h8.833zM894.857 255.217h-8.833v16.567h8.833zM911.935 255.217h-8.833v16.567h8.833zM929.012 255.217h-8.833v16.567h8.833z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "m809.577 326.247-28.701-29.834h90.391l28.701 29.834z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "m780.931 296.392-28.627 29.834v94.6h57.255v-94.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E6FDDE",
			d: "M899.968 326.247h-90.391v94.642h90.391z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "M838.201 340.145h-6.628v4.55h6.628zM838.201 353.793h-6.628v4.55h6.628zM858.086 340.145h-6.628v4.55h6.628zM858.086 353.793h-6.628v4.55h6.628zM877.97 340.145h-6.628v4.55h6.628zM877.97 353.793h-6.628v4.55h6.628zM838.201 367.44h-6.628v4.551h6.628zM858.086 367.44h-6.628v4.551h6.628zM877.97 367.44h-6.628v4.551h6.628z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#048982",
			d: "M774.248 340.145h-6.628v4.55h6.628zM774.248 353.793h-6.628v4.55h6.628zM794.133 340.145h-6.628v4.55h6.628zM794.133 353.793h-6.628v4.55h6.628zM774.248 367.44h-6.628v4.551h6.628zM794.133 367.44h-6.628v4.551h6.628z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M900.262 477.355H980V368.936c-.984-6.372-11.188-17.318-25.547-9.927.014-.203-.342-8.008-7.457-14.148-5.874-5.067-15.995-9.483-27.13-3.94-.695-6.588-10.578-14.566-19.866-14.566z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#015D10",
			d: "M978.262 467H1058v-66.775c-.98-3.925-11.19-10.666-25.55-6.114.02-.125-.34-4.932-7.45-8.713-5.88-3.121-16-5.841-27.134-2.427C997.171 378.914 987.288 374 978 374z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M992.401 327.965 971 287.021h40.48l21.4 40.944z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M1032.88 327.966h-40.479v82.53h40.479z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M971.141 287v123.59h21.24v-82.646z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1FB578",
			d: "M1017.16 343.98h-8.7v10.304h8.7zM1017.16 367.576h-8.7v10.304h8.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#57C5C6",
			d: "M1028 356.363c0 15.112 14.96 27.363 14.96 27.363s14.97-12.251 14.97-27.363S1042.96 329 1042.96 329 1028 341.251 1028 356.363"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M1043.87 353.027h-1.81v49.211h1.81z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#149977",
			d: "M977.644 407.207c-29.333 5.369-33.92-2.105-70.478 1.039-28.193 2.424-36.061 15.384-61.204 12.401-25.277-2.997-58.41-9.526-93.962.397V503h309V395.128c-43.65-10.461-63.032 8.359-83.353 12.077z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#149977",
			d: "M1077.5 401c-.5-.5-11.17-4.333-17-6l-18 7.5c-27.33 30.167-80.6 92.4-75 100s62.67 10.167 90.5 10.5c4.17-13.667 12-22.5 15.5-51.5 1.31-10.841 4.5-60 4-60.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#123E6B",
			d: "M856.189 457.544c0 15.112 14.964 27.363 14.964 27.363s14.965-12.251 14.965-27.363-14.965-27.363-14.965-27.363-14.964 12.25-14.964 27.363"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M872.056 454.208h-1.807v49.21h1.807z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#57C5C6",
			d: "M818.729 457.544c0 15.112 14.965 27.363 14.965 27.363s14.964-12.251 14.964-27.363-14.964-27.363-14.964-27.363-14.965 12.25-14.965 27.363"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M834.598 454.208h-1.807v49.21h1.807z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M781.271 457.544c0 15.112 14.964 27.363 14.964 27.363s14.965-12.251 14.965-27.363-14.965-27.363-14.965-27.363-14.964 12.25-14.964 27.363"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M797.138 454.208h-1.808v49.21h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0E664F",
			d: "M950.46 457.544c0 15.112 14.965 27.363 14.965 27.363s14.965-12.251 14.965-27.363-14.965-27.363-14.965-27.363-14.965 12.25-14.965 27.363"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M966.327 454.208h-1.808v49.21h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADD57F",
			d: "M913 457.544c0 15.112 14.965 27.363 14.965 27.363s14.964-12.251 14.964-27.363-14.964-27.363-14.964-27.363S913 442.431 913 457.544"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#006168",
			d: "M928.867 454.208h-1.808v49.21h1.808z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C9ECF4",
			d: "M993.971 101.701c0-7.156-3.701-10.691-8.454-12.01-6.389-1.774-11.3.143-13.621 2.763-.218-6.96-5.794-12.537-12.66-12.537-1.911 0-3.717.444-5.343 1.218.002-.094.014-.185.014-.28 0-7.155-5.678-12.957-12.682-12.957-2.856 0-5.483.977-7.601 2.605-.656-6.526-6.053-11.619-12.613-11.619-3.243 0-6.192 1.256-8.434 3.301-1.861-4.791-6.429-8.185-11.782-8.185-6.678 0-12.14 5.28-12.632 11.975a12.4 12.4 0 0 0-6.482-1.835c-7.003 0-12.681 5.802-12.681 12.957v28.998h124.971zM201.31 182.111c-4.221 0-8.227.919-11.86 2.547-.862-11.002-9.856-19.658-20.846-19.658s-20.025 8.701-20.85 19.741a32.9 32.9 0 0 0-10.024-1.563c-16.074 0-29.489 11.577-32.73 27.011h125.766c-1.073-15.686-13.835-28.078-29.458-28.078zM731 45.055h114.369c-.087-7.435-6.005-13.437-13.302-13.437q-.715 0-1.41.078c.044-.531.079-1.065.079-1.606 0-10.609-8.417-19.21-18.8-19.21a18.4 18.4 0 0 0-7.543 1.62C803.844 5.505 798.124 0 791.137 0c-6.988 0-12.735 5.534-13.259 12.554a20.9 20.9 0 0 0-6.373-.994c-11.762 0-21.295 9.742-21.295 21.76 0 .39.038.77.057 1.156a13 13 0 0 0-6.046-1.496c-6.846 0-12.479 5.284-13.221 12.077zM102.336 157.075a18.7 18.7 0 0 0-7.677 1.65C94.1 151.605 88.28 146 81.167 146s-12.961 5.632-13.495 12.778a21.3 21.3 0 0 0-6.487-1.012c-10.404 0-19.088 7.493-21.185 17.483h81.406c-.695-10.152-8.954-18.174-19.068-18.174z"
		})
	]
});
export default SvgEmptyStateFullPage2;
